/**
 * @generated SignedSource<<bd104061f1e553a711d36509738613bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WebFormQuestionResponseTableFieldFragment$data = {
  readonly answer: {
    readonly body: string | null;
    readonly isSkipped: boolean;
    readonly selectedOptions: ReadonlyArray<string> | null;
  } | null;
  readonly options: ReadonlyArray<{
    readonly id: string;
    readonly label: string;
  }> | null;
  readonly type: WebFormQuestionType;
  readonly " $fragmentType": "WebFormQuestionResponseTableFieldFragment";
};
export type WebFormQuestionResponseTableFieldFragment$key = {
  readonly " $data"?: WebFormQuestionResponseTableFieldFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebFormQuestionResponseTableFieldFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentUsageId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebFormQuestionResponseTableFieldFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormQuestionOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentUsageId",
          "variableName": "contentUsageId"
        },
        {
          "kind": "Variable",
          "name": "organizationMembershipId",
          "variableName": "organizationMembershipId"
        }
      ],
      "concreteType": "WebFormAnswer",
      "kind": "LinkedField",
      "name": "answer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSkipped",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "selectedOptions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebFormQuestion",
  "abstractKey": null
};

(node as any).hash = "1db4e337e165228d704751c306b90726";

export default node;
